export type TourAction = 'open-drawer' | 'close-drawer';

type Listener = (action: TourAction) => void;

const listeners = new Set<Listener>();

export function subscribeTourAction(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitTourAction(action: TourAction) {
  listeners.forEach((listener) => listener(action));
}
